import React from 'react';
import { ReactComponent as ActiveUserDot } from 'images/active-user-dot.svg';



const Avatar = ({ size = 28, image, style, className, children, user, isOnline = false, dotStyle, ...rest }) => {
  let defaultImage = image.includes('default-avatar.jpg')
  if (user !== undefined && user !== null) {

    var acronym = user.split(/\s/).reduce((response, word) => response += word.slice(0, 1), '').slice(0, 2)

  }
  return (
    <>
      {defaultImage ?
        <div className={`position-relative avatar ${className}`} style={{ backgroundColor: '#253245', width: size, height: size, position: 'relative', ...style }}
        >
          <span className="default-avatar-background">{acronym && acronym}</span>

        </div>
        :
        <div
          className={`position-relative avatar ${className}`}
          {...rest}
          style={{ backgroundImage: `url('${image}')`, width: size, height: size, position: 'relative', ...style }}
        >
          {isOnline ? <ActiveUserDot
            className={'position-absolute user-online-indicator-dot'}
            style={{
              bottom: 0,
              right: -1,
              ...dotStyle,
            }}
          /> : null}

          {children}
        </div>}
    </>

  );
};

export default Avatar;
